import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../../../helpers/custom-prop-types';
import ProfessionalMyPageTopMySolutionItemBody from './MySolutionItemBody';
import ProfessionalMyPageTopMySolutionItemHeader from './MySolutionItemHeader';
const ProfessionalMyPageTopMySolutionItem = ({ item, profile }) => (_jsxs("div", Object.assign({ className: 'my-solution consultant' }, { children: [_jsx(ProfessionalMyPageTopMySolutionItemHeader, { item: item, profile: profile }), _jsx(ProfessionalMyPageTopMySolutionItemBody, { item: item, profile: profile })] })));
ProfessionalMyPageTopMySolutionItem.propTypes = {
    item: propShape().isRequired,
    profile: propShape().isRequired,
};
export default ProfessionalMyPageTopMySolutionItem;
